import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import _ from "lodash";
import FilterGroup from "../../common/reports/FilterGroup";
import FilterItem from "../../common/reports/FilterItem";
import Filters from "../../common/reports/Filters";
import { LIKE } from "../../common/reports/reportConstants";
import { createFilterParam } from "../../common/reports/reportUtils";
import Button from "../../framework/Button";
import GlobalContext from "../../framework/GlobalContext";
import Shortcut from "../../framework/Shortcut";
import { isEmpty } from "../../utils/utils";
import NumberInput from "../../framework/NumberInput";
import SelectInput from "../../framework/SelectInput";
import { fetchAllSpeciality } from "../../services/doctor-service";

const SpecialityMasterReportFilter = ({
  reportRef,
  onFilterShow,
  applyFilterOnMount = true,
}) => {
  const [specialityName, setSpecialityName] = useState("");

  // const [orderBy] = useState([
  //   { fieldName: "specialityName", orderType: "asc" },
  // ]);
  const [limit, setLimit] = useState(100);
  const smr_filter_speciality_master_name = useRef();
  const applyFilterRef = useRef();
  const { setCurrentComponent } = useContext(GlobalContext);
  const [specialityOptions, setSpecialityOptions] = useState([]);
  const applyFilterHandler = useCallback(
    (isFilterChanged = false) => {
      let filters = [];
      let result = {};
      if (!isEmpty(specialityName)) {
        filters.push(createFilterParam("name", specialityName, "string", LIKE));
      }
      if (isFilterChanged) {
        result.filters = filters;
      }
      if (!isEmpty(limit)) {
        result.limit = limit;
      }
      reportRef.current?.applyFilters(result);
    },
    [specialityName, reportRef, limit]
  );
  let debounce = useCallback(
    _.debounce(() => {
      applyFilterHandler();
    }, 300),
    []
  );
  const filterListener = useCallback((event) => {
    const key = event.key.toLowerCase();
    const ctrl = event.ctrlKey;
    if (ctrl && key === "enter") {
      return applyFilterRef.current.click();
    }
  }, []);

  const filterContent = (
    <>
      <FilterGroup>
        <FilterItem>
          <SelectInput
            id="smr_filter_speciality_master_name"
            label="Speciality Name"
            ref={smr_filter_speciality_master_name}
            onFocus={() =>
              setCurrentComponent("smr_filter_speciality_master_name")
            }
            value={specialityName}
            options={specialityOptions}
            disableClearable={false}
            getOptionLabel={(option) => option.label || option}
            isOptionEqualToValue={(option, value) => {
              return option.label === value.label || value === "";
            }}
            onChange={(e, option) => {
              setSpecialityName(option?.label || "");
            }}
            freeSolo
            onInputChange={(e) => {
              if (!e) return;
              setSpecialityName(e.target.value);
              if (!e.target.value) {
                setSpecialityName(null);
                return;
              }
              if (e?.target?.value?.length > 2) {
                fetchAllSpeciality(`name=${e.target.value.trim()}`).then(
                  (resp) => {
                    let updatedResp =
                      resp?.rows?.map((speciality) => ({
                        id: speciality.specialityId,
                        label: speciality.name,
                      })) || [];
                    setSpecialityOptions(updatedResp);
                  }
                );
              }
            }}
            markers={JSON.stringify({
              up: "smr_filter_limit",
              down: "smr_filter_speciality_master_name",
              right: "smr_filter_limit",
              left: "smr_filter_speciality_master_name",
            })}
          />
        </FilterItem>
      </FilterGroup>
      <FilterGroup>
        <FilterItem>
          <NumberInput
            label="Limit"
            id="smr_filter_limit"
            value={limit}
            onFocus={() => setCurrentComponent("smr_filter_limit")}
            onValueChange={(values, e) => {
              setLimit(values.floatValue);
            }}
            inputProps={{
              "data-markers": JSON.stringify({
                up: "smr_apply_filter_button",
                left: "smr_filter_speciality_master_name",
                down: "smr_filter_speciality_master_name",
                right: "smr_apply_filter_button",
              }),
            }}
          />
        </FilterItem>
      </FilterGroup>
    </>
  );
  const filterFooter = (
    <>
      <FilterGroup>
        <FilterItem>
          <Button
            id="smr_apply_filter_button"
            label="Apply"
            ref={applyFilterRef}
            endIcon={<Shortcut keys={["Ctrl", "Enter"]} />}
            onClick={() => {
              applyFilterHandler(true);
            }}
            markers={JSON.stringify({
              up: "smr_apply_filter_button",
              left: "smr_filter_limit",
              right: "smr_apply_filter_button",
              down: "smr_filter_limit",
            })}
          />
        </FilterItem>
      </FilterGroup>
    </>
  );

  useEffect(() => {
    if (onFilterShow) {
      smr_filter_speciality_master_name?.current.focus({ preventScroll: true });
    }
  }, [onFilterShow]);
  useEffect(() => {
    if (onFilterShow) document.addEventListener("keyup", filterListener, false);
    return () => {
      document.removeEventListener("keyup", filterListener, false);
    };
  }, [filterListener, onFilterShow]);
  useEffect(() => {
    if (applyFilterOnMount) debounce();
    return () => {
      debounce.cancel();
    };
  }, [applyFilterOnMount, debounce]);

  return <Filters filterContent={filterContent} filterFooter={filterFooter} />;
};

export default SpecialityMasterReportFilter;
